"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractAddresses = exports.limirOrderProtocolAdresses = exports.RFQ_ORDER_STRUCTURE = exports.ORDER_STRUCTURE = exports.EIP712_DOMAIN = exports.ERC20_ABI = exports.LIMIT_ORDER_PROTOCOL_ABI = exports.CALL_RESULTS_PREFIX = exports.ZERO_ADDRESS = exports.ZX = exports.TypedDataVersion = exports.PROTOCOL_VERSION = exports.PROTOCOL_NAME = void 0;
const tslib_1 = require("tslib");
const LimitOrderProtocol_json_1 = tslib_1.__importDefault(require("./abi/LimitOrderProtocol.json"));
const ERC20ABI_json_1 = tslib_1.__importDefault(require("./abi/ERC20ABI.json"));
const eth_sig_util_1 = require("@metamask/eth-sig-util");
const limit_order_protocol_model_1 = require("./model/limit-order-protocol.model");
exports.PROTOCOL_NAME = '1inch Aggregation Router';
exports.PROTOCOL_VERSION = '5';
exports.TypedDataVersion = eth_sig_util_1.SignTypedDataVersion.V4;
exports.ZX = '0x';
exports.ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
exports.CALL_RESULTS_PREFIX = 'CALL_RESULTS_';
exports.LIMIT_ORDER_PROTOCOL_ABI = LimitOrderProtocol_json_1.default;
exports.ERC20_ABI = ERC20ABI_json_1.default;
exports.EIP712_DOMAIN = [
    { name: 'name', type: 'string' },
    { name: 'version', type: 'string' },
    { name: 'chainId', type: 'uint256' },
    { name: 'verifyingContract', type: 'address' },
];
exports.ORDER_STRUCTURE = [
    { name: 'salt', type: 'uint256' },
    { name: 'makerAsset', type: 'address' },
    { name: 'takerAsset', type: 'address' },
    { name: 'maker', type: 'address' },
    { name: 'receiver', type: 'address' },
    { name: 'allowedSender', type: 'address' },
    { name: 'makingAmount', type: 'uint256' },
    { name: 'takingAmount', type: 'uint256' },
    { name: 'offsets', type: 'uint256' },
    { name: 'interactions', type: 'bytes' },
];
exports.RFQ_ORDER_STRUCTURE = [
    { name: 'info', type: 'uint256' },
    { name: 'makerAsset', type: 'address' },
    { name: 'takerAsset', type: 'address' },
    { name: 'maker', type: 'address' },
    { name: 'allowedSender', type: 'address' },
    { name: 'makingAmount', type: 'uint256' },
    { name: 'takingAmount', type: 'uint256' },
];
exports.limirOrderProtocolAdresses = {
    [limit_order_protocol_model_1.ChainId.etherumMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.binanceMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.polygonMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.optimismMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.arbitrumMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.auroraMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.gnosisMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.avalancheMainnet]: '0x1111111254eeb25477b68fb85ed929f73a960582',
    [limit_order_protocol_model_1.ChainId.fantomMainnet]: '0x1111111254EEB25477B68fb85Ed929f73A960582',
    [limit_order_protocol_model_1.ChainId.klaytnMainnet]: '0x1111111254EEB25477B68fb85Ed929f73A960582',
};
/**
 * @deprecated Change to `limirOrderProtocolAdresses`
 */
exports.contractAddresses = exports.limirOrderProtocolAdresses;
//# sourceMappingURL=limit-order-protocol.const.js.map